import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SharedService } from "../../../services/sharedService";
import { DiscountRequest, DiscountResponse } from "../models/disount.models";
import { Observable } from "rxjs";

@Injectable({
  providedIn:'root'
})
export class DiscountService {
apiDomain:string;
basePath:string;
constructor(private http:HttpClient,private sharedService:SharedService) {
  this.apiDomain = sharedService.apiDomain;
  this.basePath = 'parking-places/parking-discounts/';
}

  deleteDiscount(id:string){
    let params = `?parking_place=${id}`;
    return this.http
      .delete(`${this.apiDomain}${this.basePath}${params}`, {
        headers: this.createAuthorizationHeader(),
      })
  }

  postDiscount(discountReq:DiscountRequest){
    return this.http.post(`${this.apiDomain}${this.basePath}`,discountReq,{
      headers:this.createAuthorizationHeader(),

    });
  }

  updateDiscount(discountReq:DiscountRequest){
    return this.http
      .put(`${this.apiDomain}${this.basePath}?parking_place=${discountReq.parking_place}`,
      {discount_percent:discountReq.discount_percent},{
        headers:this.createAuthorizationHeader()
      });
  }

  getAll():Observable<DiscountResponse[]>{
    return this.http.get<DiscountResponse[]>(`${this.apiDomain}${this.basePath}`,{
      headers:this.createAuthorizationHeader()
    });
  }

  getParkingPlaces(){
    const headers = this.createAuthorizationHeader();
    return this.http.get(this.apiDomain + "parking-places/", {
      headers: this.createAuthorizationHeader()
    });
  }


  private createAuthorizationHeader() {
    console.log('create authorization header');
    return new HttpHeaders({
      Authorization: "JWT " + localStorage.getItem("jwt"),
    });
  }

}
